import { useState } from "react";
import SubSubMenu from "../components/sub-sub-menu";
import SyncedOrgChart from "./org-chart/synced-org-chart";
import SyncedCardStack from "./card-stack/synced-card-stack";
import DependencyMapping from "./dependency-mapping/dependency-mapping";
import SyncedGanttChart from "./gantt-chart/synced-gantt-chart";

export type SubSubMenuType = "org-chart" | "card-stack" | "dependency-mapping" | "gantt-chart";

export default function SyncedWidgetsSubSubMenu({
  subMenuType,
  onGoBack,
  onComplete,
}: {
  subMenuType: SubSubMenuType;
  onGoBack: () => void;
  onComplete: (data: unknown) => void;
}) {
  const [hideBackButton, setHideBackButton] = useState(false);

  return (
    <SubSubMenu onGoBack={onGoBack} subMenuType={subMenuType} hideBackButton={hideBackButton}>
      {subMenuType === "org-chart" && <SyncedOrgChart onComplete={onComplete} />}
      {subMenuType === "card-stack" && <SyncedCardStack onComplete={onComplete} />}
      {subMenuType === "dependency-mapping" && <DependencyMapping onComplete={onComplete} />}
      {subMenuType === "gantt-chart" && (
        <SyncedGanttChart onComplete={onComplete} onHideBackButton={setHideBackButton} />
      )}
    </SubSubMenu>
  );
}
